import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import { getData } from '@portal-internet/bff';
import Mosaic from 'components/3catinfo/Mosaic';
import Icona from 'components/3catinfo/ui/Icona';
import __isEmpty from 'lodash/isEmpty';
import styles from './menuDirectes.module.scss';
import Titol from 'components/3catinfo/Titol';

const useDirectesQuery = () => {
    const [data, setData] = useState({});
    const [enabled, setEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const urlDirectesTV =
        'https://api.3cat.cat/arafem?_format=json&geo=cat&grup=actualitat&tipus=tvdigital&version=1.0&cache=90&geo=cat&https=true&master=yes';
    const urlDirectesRadio =
        'https://api.3cat.cat/arafem?_format=json&geo=cat&tipus=audio&grup=actualitat&version=1.0&cache=90&https=true&master=yes';
    const urlDirectesOca =
        'https://api.3cat.cat/arafem?_format=json&geo=cat&grup=actualitat&tipus=ocasionals&version=1.0&cache=90&geo=cat&https=true&master=yes';
    const refetchInterval = 60000;

    const {
        isLoading: isLoadingTv,
        error: errorTv,
        data: dataTV,
        refetch: refetchTV
    } = useQuery(['menu-directes', { url: urlDirectesTV }], getData, {
        refetchOnMount: 'always',
        enabled,
        refetchInterval
    });

    const {
        isLoading: isLoadingRadio,
        error: errorRadio,
        data: dataRadio,
        refetch: refetchRadio
    } = useQuery(['menu-directes', { url: urlDirectesRadio }], getData, {
        refetchOnMount: 'always',
        enabled,
        refetchInterval
    });

    const {
        isLoading: isLoadingOca,
        error: errorOca,
        data: dataOca,
        refetch: refetchOca
    } = useQuery(['menu-directes', { url: urlDirectesOca }], getData, {
        refetchOnMount: 'always',
        enabled,
        refetchInterval
    });

    const refetch = () => {
        setEnabled(true);
        refetchTV();
        refetchRadio();
        refetchOca();
    };

    useEffect(() => {
        setIsLoading(isLoadingRadio || isLoadingTv || isLoadingOca);
    }, [isLoadingRadio, isLoadingTv, isLoadingOca]);

    useEffect(() => {
        if (dataTV && dataRadio && dataOca) {
            const canalsTV = dataTV?.canal.filter((item) => item.ara_fem !== undefined);
            const canalsRadio = dataRadio?.canal.filter((item) => item.ara_fem !== undefined);
            const canalsOca = dataOca?.canal.filter((item) => item.ara_fem !== undefined);
            setData({ canalsTV, canalsRadio, canalsOca });
        }
    }, [dataTV, dataRadio, dataOca]);

    return {
        isLoading,
        data,
        refetch,
        setEnabled
    };
};

const MenuDirectes = (props) => {
    const { openDropdown } = props;
    const { isLoading, data, refetch, setEnabled } = useDirectesQuery();

    useEffect(() => {
        setEnabled(openDropdown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openDropdown]);

    const hasOcasionals = (items) => {
        for (var key in items) {
            if (items.hasOwnProperty(key)) {
                if (items[key].ara_fem) {
                    return 'EXCLUSIUS DIGITALS';
                }
            }
        }
        return false;
    };
    return (
        <div className={styles.menuDirectes} key={Date.now()}>
            <div className={styles.columnesDirectes}>
                <Mosaic
                    format='directes'
                    items={data?.canalsTV}
                    isLoading={isLoading}
                    skeletonItems={2}
                    numColumns={1}
                    estilMosaic='menuDirectes'
                />
                <Mosaic
                    format='directes'
                    items={data?.canalsRadio}
                    isLoading={isLoading}
                    skeletonItems={2}
                    numColumns={1}
                    estilMosaic='menuDirectes'
                    tipus='radio'
                />
            </div>
            {!__isEmpty(data?.canalsOca) && <Titol titol={hasOcasionals(data?.canalsOca)} tag='h2' estil='dropdownExclusius' />}
            <Mosaic
                format='directes'
                items={data?.canalsOca}
                isLoading={isLoading}
                skeletonItems={2}
                numColumns={2}
                numColumnsMobile={1}
                estilMosaic='menuDirectes'
            />
        </div>
    );
};

export default MenuDirectes;
